var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreategrpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_chat_icon_",
    "data-name": "new chat icon ",
    transform: "translate(-713 -393)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18496",
    "data-name": "Rectangle 18496",
    width: 24,
    height: 24,
    transform: "translate(713 393)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_",
    "data-name": "icon ",
    transform: "translate(713 393.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59131",
    "data-name": "Path 59131",
    d: "M11,4H4A2,2,0,0,0,2,6V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V13",
    fill: "none",
    stroke: "#bdbdbd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59132",
    "data-name": "Path 59132",
    d: "M18.5,2.5a2.121,2.121,0,0,1,3,3L12,15,8,16l1-4Z",
    fill: "none",
    stroke: "#bdbdbd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreategrpIcon);
export default __webpack_public_path__ + "static/media/creategrpIcon.410dbedb0c28b175c9b268ed2155ea57.svg";
export { ForwardRef as ReactComponent };